import React from "react";
import { Row, Col, Card } from "@pankod/refine-antd";
import { TopShopsColumn } from "../charts/TopShopsColumn";
import { ShopMetricsTable } from "../tables/ShopMetricsTable";

interface ShopAnalysisTabProps {
  dateRange: [string, string];
  shopCode: string | null;
}

export const ShopAnalysisTab: React.FC<ShopAnalysisTabProps> = ({
  dateRange,
  shopCode,
}) => {
  return (
    <>
      <Row gutter={[16, 16]}>
        <Col xs={24}>
          <Card title="En Aktif 20 Mağaza">
            <TopShopsColumn dateRange={dateRange} shopCode={shopCode} />
          </Card>
        </Col>
      </Row>
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24}>
          <ShopMetricsTable dateRange={dateRange} shopCode={shopCode} />
        </Col>
      </Row>
    </>
  );
};
